import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppConfig } from '../../features/app-config';

interface ProtectedRouteProps {
  element: React.ReactElement;
  path: string;
}

/**
 * ProtectedRoute component for unified role-based access control
 * 
 * @param element - The component to render if access is granted
 * @param path - Path to check against centralized page permissions
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  element, 
  path 
}) => {
  const { canVisitPage } = useAppConfig();
  
  const hasAccess = canVisitPage(path);
  
  if (!hasAccess) {
    return <Navigate to="/not-found" replace />;
  }
  
  return element;
};
